import React, { memo, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { formatRecordingIdDateParts } from "../../../utils/results/recordingIdTime";
import { isManualAudioCompleteDoc } from "../../../utils/results/manualAudioStatus";
import {
  pickManualAudioDurationHint,
  pickManualAudioSource,
} from "../../../utils/results/manualAudioPlayback";
import ResultViewScaffold from "../ResultViewScaffold";
import VoiceMemoPlayer from "../VoiceMemoPlayer";
import {
  getResultModeIcon,
  getResultModeLabel,
} from "../../../utils/results/resultModePresentation";

function ManualAudioResultViewImpl({ data, docId, variant, footer = null }) {
  const { t, i18n } = useTranslation();

  const recordingTime = useMemo(
    () =>
      formatRecordingIdDateParts(
        docId,
        i18n.resolvedLanguage || i18n.language || "en-GB",
      ),
    [docId, i18n.resolvedLanguage, i18n.language],
  );

  const audioSrc = useMemo(() => pickManualAudioSource(data), [data]);
  const durationHint = useMemo(() => pickManualAudioDurationHint(data), [data]);

  return (
    <ResultViewScaffold
      title={getResultModeLabel(variant, t)}
      icon={getResultModeIcon(variant)}
      recordingTime={recordingTime}
      footer={footer}
    >
      {/* <Spacer /> */}
      {audioSrc ? (
        <VoiceMemoPlayer src={audioSrc} durationHint={durationHint} />
      ) : (
        <p className="muted-text">
          {t(
            "result.manualAudio.player.noAudio",
            "Audio recording unavailable.",
          )}
        </p>
      )}
    </ResultViewScaffold>
  );
}

const ManualAudioResultView = memo(ManualAudioResultViewImpl);

ManualAudioResultView.isReady = (data) => {
  return isManualAudioCompleteDoc(data);
};

export default ManualAudioResultView;
